<template>
  <appTable
    v-if="shouldRenderConfig"
    :tableName="name"
    :tableClass="getClassName"
  >
    <slot></slot>
  </appTable>
</template>
<script>
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    name: () => {
      return "Others";
    }
  }
};
</script>
